import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { BrowserRouter } from 'react-router-dom'
import store from './redux/store'
import Main from './Main'
import './index.css'
import './i18n/Config'
import reportWebVitals from './reportWebVitals'

const muiTheme = createTheme({
    typography: {
        // Use the system font.
        fontFamily: 'Prompt_Light, sans-serif',
        button: {
            textTransform: 'none',
        },
        body1: {
            fontSize: '16px',
        },
        body2: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '16px',
        },
    },
    palette: {
        primary: {
            main: '#318AF1',
            dark: '#2C64A3',
            light: '#E9ECFA',
        },
        secondary: {
            main: '#2364C4',
            light: '#123671',
            dark: '#0F192C',
        },
        text: {
            primary: '#636363',
            secondary: '#FFFFFF',
            disabled: '#C4C4C4',
        },
        background: {
            default: '#F8F9FD',
        },
        getContrastText: (color: string) => {
            //if (color === 'gradient') return 'linear-gradient(to top, #1A3A6F, #207CEB)'
            if (color === 'gradient') return 'linear-gradient(180deg, #2780F9 50.05%, #0A347A 99.19%)'
            if (color === 'gradient-header') return 'linear-gradient(180deg, #207CEB 52.28%, #1A3A6F 159.64%)'
            else if (color === 'shadow-box') return '0px 0px 10px 5px rgba(0, 0, 0, 0.15)'
            else if (color === 'shadow-box-blue') return '0px 0px 10px 5px rgba(56, 170, 235, 0.53)'
            else if (color === 'shadow-bottom') return '0px 1px 10px 0px rgba(0, 0, 0, 0.75)'
            else if (color === 'shadow-bottom-blue') return '0px 1px 10px 0px rgba(56, 170, 235, 0.53)'
            else if (color === 'shadow-bottom-gray') return '0px 1px 10px 0px rgba(184, 184, 184, 0.53)'
            else if (color === 'black') return '#000000'
            else if (color === 'green') return '#A0CD59'
            else if (color === 'yellow') return '#F6D167'
            else if (color === 'red') return '#FFADAD'
            else if (color === 'fail') return '#FA5C52'
            else if (color === 'required') return '#F13131'
            else if (color === 'bg-backoffice') return '#E5E5E5'
            else if (color === 'bg-login-right') return '#EFF6FC'
            else if (color === 'bg-cover-no-image') return '#F5F5F5'
            else return color
        },
    },
})

if (process.env.REACT_APP_ENVIRONMENT !== 'DEV') {
    // clearConsole()
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store()}>
            <ThemeProvider theme={muiTheme}>
                <BrowserRouter basename={process.env.REACT_APP_FOLDER_APPLICATION}>
                    <Main />
                </BrowserRouter>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
